import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ClientService, httpHeaders } from '../../client.service';

import { ErrorDatabaseQueryParams, ErrorDatabaseResponse } from './service-documents.model';

@Injectable()
export class ServiceDocumentsApi {
  constructor(private clientService: ClientService) {}

  /**
   * Error Database
   * @param params
   */
  listErrorsDatabase(params: ErrorDatabaseQueryParams): Observable<ErrorDatabaseResponse> {
    const endpoint = `service-documents/v3/error-database`;

    return this.clientService.get(endpoint, params, httpHeaders);
  }
}
